import PropTypes from 'prop-types';
import { PureComponent, Suspense } from 'react';

import RenderWhenVisible from 'Component/RenderWhenVisible';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

import {
    CATALOG_PRODUCT_LIST,
    SLIDER
} from './WidgetFactory.config';

import './WidgetFactory.style.scss';

export const SaleCountdownWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget" */
    'Component/SaleCountdownWidget'
), 2);
export const ProductListWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-product-list" */
    'Component/ProductListWidget'
), 2);
export const HomeSlider = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-slider" */
    'Component/SliderWidget'
), 2);

export const SubCategoriesSliderWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-recently-viewed" */
    'Component/SubCategoriesSliderWidget'
), 2);

export const ShippingMethodSimulatorWidget = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "widget-shipping-method-simulatro" */
    'Component/ShippingMethodSimulatorWidget'
), 2);

/** @namespace Bodypwa/Component/WidgetFactory/Component */
export class WidgetFactoryComponent extends PureComponent {
    static propTypes = {
        type: PropTypes.string.isRequired,
        sliderId: PropTypes.string,
        displayType: PropTypes.string,
        productsCount: PropTypes.number,
        showPager: PropTypes.number,
        storeId: PropTypes.string,
        title: PropTypes.string,
        conditionsEncoded: PropTypes.string,
        'data-category': PropTypes.string
    };

    static defaultProps = {
        sliderId: null,
        displayType: 'default',
        productsCount: 10,
        showPager: 0,
        storeId: 'default-store',
        title: '',
        conditionsEncoded: '',
        'data-category': null
    };

    renderMap = {
        [SLIDER]: {
            component: HomeSlider,
            fallback: this.renderSliderFallback
        },
        [CATALOG_PRODUCT_LIST]: {
            component: ProductListWidget
        },
        saleCountDown: {
            component: SaleCountdownWidget
        },
        subCategoriesSlider: {
            component: SubCategoriesSliderWidget
        },
        simulateShippingRate: {
            component: ShippingMethodSimulatorWidget
        }
    };

    renderSliderFallback() {
        return (
            <div block="WidgetFactory" elem="SliderPlaceholder" />
        );
    }

    renderDefaultFallback() {
        return <div />;
    }

    renderWidget() {
        const {
            type,
            sliderId = null,
            displayType,
            productsCount,
            showPager,
            storeId,
            title,
            conditionsEncoded,
            placement,
            addToCartButton,
            'data-category': categoryId
        } = this.props;
        const {
            component: Widget
        } = this.renderMap[type] || {};

        return (
                <Widget
                    sliderId={ sliderId }
                    displayType={ displayType }
                    productsCount={ productsCount }
                    showPager={ showPager }
                    storeId={ storeId }
                    title={ title }
                    placement={ placement }
                    categoryId={ categoryId }
                    conditionsEncoded={ conditionsEncoded }
                    addToCartButton={ addToCartButton }
                    widgetProps={ this.props }
                />
        );
    }

    renderContent() {
        const {
            type
        } = this.props;

        const {
            component: Widget,
            fallback
        } = this.renderMap[type] || {};

        if (type === 'saleCountDown') {
            return this.renderWidget();
        }

        if (Widget !== undefined) {
            return (
                <RenderWhenVisible fallback={ fallback } elem={ type }>
                    { this.renderWidget() }
                </RenderWhenVisible>
            );
        }

        return null;
    }

    renderFallback() {
        const { type } = this.props;
        const { fallback = this.renderDefaultFallback } = this.renderMap[type] || {};

        return fallback();
    }

    render() {
        return (
            <Suspense fallback={ this.renderFallback() }>
                { this.renderContent() }
            </Suspense>
        );
    }
}

export default WidgetFactoryComponent;
